import { type FC, type PropsWithChildren } from 'react';
import { Controller, type Control } from 'react-hook-form';
import { FormControl, FormHelperText, Grid, TextField } from '@mui/material';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { getFormErrorAttributes } from '#apps/client-web/app/helpers/react-hook-form';

import {
  SubFormDialog,
  type SubFormDialogProps,
} from '#packages/web/layouts/dialog/templates/sub-form';

export type IdentificationFormDialogProps = Pick<
  SubFormDialogProps,
  'onClose' | 'open'
> & {
  control: Control<EditAuditFormBackgroundData>;
};

export const IdentificationFormDialog: FC<
  PropsWithChildren<IdentificationFormDialogProps>
> = ({
  open,

  control,

  onClose,
}) => (
  <SubFormDialog title="Identification" open={open} onClose={onClose}>
    <Grid container spacing={2}>
      <Controller
        control={control}
        name="general.organizationName"
        rules={{ maxLength: 120 }}
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              autoFocus
              label="Client Organization"
              type="text"
              variant="outlined"
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="general.buildingName"
        rules={{
          maxLength: 120,
        }}
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              label="Building Name"
              type="text"
              variant="outlined"
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="general.yearBuilt"
        rules={{ maxLength: 120 }}
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              label="Construction year"
              type="number"
              variant="outlined"
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
    </Grid>
  </SubFormDialog>
);
